import { Dict } from "../../defines";
import useWebsocket from "../websocket/useWebSocket";
import useUtmParams from "./useUtmParams";

export const useMetrics = () => {
  const utmParams = useUtmParams();
  const sendMessage = useWebsocket({});

  return (params: Dict) => {
    const p = utmParams ? utmParams.get() : {};
    sendMessage(
      JSON.stringify({ method: "event", params: { ...p, ...params } }),
    );
  };
};
